import {
	HistorialCitasProvider,
	useHistorialCitas,
} from './HistorialCitasContext';
import HistorialForm from './views/FormView';
import ResultsView from './views/ResultsView';
import { useLayoutEffect } from 'react';
import {
	CancelarCitaModal,
	ConfirmacionCancelacionModal,
	FormResponseModal,
} from './views/Modals';

function Content() {
	const { view } = useHistorialCitas();

	useLayoutEffect(() => {
		document.documentElement.scrollTo(0, 0);
	}, [view]);

	switch (view) {
		case 'form':
			return <HistorialForm />;
		case 'loading':
			return <HistorialForm />;
		case 'response':
			return <ResultsView />;
		default:
			return null;
	}
}

export default function ConsultaMedicamentos() {
	return (
		<HistorialCitasProvider>
			<Content />
			<FormResponseModal />
			<CancelarCitaModal />
			<ConfirmacionCancelacionModal />
		</HistorialCitasProvider>
	);
}
